import { JSX, useCallback } from "react";

import { IconButton, TableCell } from "@mui/material";
import TableRow from "@mui/material/TableRow";

import DeleteIcon from "@mui/icons-material/Delete";

import IndexCheckbox from "utils/elements/IndexCheckbox";
import { ChangeEvent, EventGroup } from "utils/history/Event";

import { EvaluationRight } from "core/blueprint/trajectory/TrajectoryBlueprintService";
import { RoleRowProps } from "./RoleTable";

function EvaluationRoleRow(props: RoleRowProps): JSX.Element {
	const toggleRight = useCallback(
		(right: EvaluationRight, enabled: boolean): void => {
			const basePath = `/roles/${props.index}/evaluationRights`;

			const events = getImpliedRights(right, enabled)
				.filter(impliedRight => enabled !== hasRight(impliedRight))
				.map(impliedRight => {
					const path = `${basePath}/${impliedRight}`;
					return new ChangeEvent(path, !enabled, enabled);
				});

			const group = new EventGroup(events);
			props.onChange(group);
		},
		[props.index, props.role.evaluationRights, props.onChange]
	);

	function getImpliedRights(
		right: EvaluationRight,
		enabled: boolean
	): EvaluationRight[] {
		const rights = [right];
		if (enabled) {
			if (right === EvaluationRight.WRITE) {
				rights.push(EvaluationRight.READ);
			}
		} else {
			if (right === EvaluationRight.READ) {
				rights.push(EvaluationRight.WRITE);
			}
		}

		return rights;
	}

	const onDelete = useCallback((): void => {
		props.onDelete(props.index);
	}, [props.index, props.onDelete]);

	function hasRight(right: EvaluationRight): boolean {
		return props.role.evaluationRights[right] === true;
	}

	return (
		<TableRow>
			<TableCell component="th" scope="row">
				{props.role.name}
			</TableCell>
			<TableCell padding="checkbox" align="center">
				<IndexCheckbox
					index={EvaluationRight.WRITE}
					disabled={!props.editable}
					status={hasRight(EvaluationRight.WRITE)}
					onChange={toggleRight}
				/>
			</TableCell>
			<TableCell padding="checkbox" align="center">
				<IndexCheckbox
					index={EvaluationRight.READ}
					disabled={!props.editable}
					status={hasRight(EvaluationRight.READ)}
					onChange={toggleRight}
				/>
			</TableCell>
			<TableCell padding="none" align="right">
				<IconButton
					size="small"
					disabled={!props.editable}
					onClick={onDelete}>
					<DeleteIcon fontSize="inherit" />
				</IconButton>
			</TableCell>
		</TableRow>
	);
}

export default EvaluationRoleRow;
